module.exports = __webpack_public_path__ + "static/img/icon_dh_07.d960d722.png";